import { vfs } from "./vfs_fonts.js";
import pdfmake from "pdfmake/build/pdfmake.js";

pdfmake.addVirtualFileSystem(vfs);

pdfmake.addFonts({
	Roboto: {
		normal: "Roboto-Regular.ttf",
		bold: "Roboto-Medium.ttf",
		italics: "Roboto-Italic.ttf",
		bolditalics: "Roboto-MediumItalic.ttf",
	},
});

/**
 * Return a PDF generator object using the pdfmake library.
 *
 * @param {{}} docDefinition - The specification for the PDF to
 * generate. See pdfmake documentation for details.
 */
export function create(docDefinition) {
	return pdfmake.createPdf(docDefinition);
}

/**
 * Convert `url` to a data url (i.e.,
 * "data:[<mediatype>][;base64],<data>").
 *
 * @param {string} url - The location of the image to convert.
 * @return {Promise} A promise resolving with a PDF image definition to be
 * embedded in a PDF docDefinition. If URL can't be fetched, the
 * promise resolves with an empty PDF definition which can still be
 * embedded as is in a docDefinition but which will show no image.
 */
function imageUrlToDefinition(url) {
	return new Promise((resolve) => {
		const image = new Image();

		image.onerror = () => resolve({});

		image.onload = function () {
			const canvas = document.createElement("canvas");
			canvas.width = this.naturalWidth;
			canvas.height = this.naturalHeight;
			canvas.getContext("2d").drawImage(this, 0, 0);
			resolve({ image: canvas.toDataURL("image/png", 1.0) });
		};

		image.src = url;
	});
}

/**
 * Same as `imageUrlToDefinition` but make sure the resulting PDF
 * image definition has a reasonable size for the agency print logo.
 *
 * @param {string} url - The location of the image to convert.
 * @return {Promise} A promise resolving with a PDF image definition to be
 * embedded in a PDF docDefinition. If URL can't be fetched, the
 * promise resolves with an empty PDF definition which can still be
 * embedded as is in a docDefinition but which will show no image.
 */
export function agencyPrintLogoToDefinition(url) {
	return imageUrlToDefinition(url).then((imageDefinition) => {
		if (imageDefinition.image) {
			// Make sure the logo doesn't take too much space in the
			// PDF. The max height below is the same we use when
			// printing the report directly from the browser.
			imageDefinition.fit = [
				180, // max width
				40, // max height
			];
		}

		return imageDefinition;
	});
}
